module.exports = __webpack_public_path__ + "static/media/m0.dc71ebb4.svg";